import { render, staticRenderFns } from "./Found.vue?vue&type=template&id=1d4c8ee6&"
import script from "./Found.vue?vue&type=script&lang=js&"
export * from "./Found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports